import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { CustomizationService } from 'src/services/customization.service';
import { CustomizationStoreService } from 'src/services/customization.store.service';
import { normalizeWidgetLang } from 'src/services/lang.utils';

@Component({
  selector: 'vex-terms-cert',
  templateUrl: './terms.component.html',
  styleUrls: ['./terms.component.scss']
})
export class TermsCertificateComponent implements OnInit {
  loading = true;
  terms_and_conditions;
  flowName;
  funderConfig;
  funderStyles;
  flowConfig;

  texts = {
    cancel: 'Cancelar',
    accept: 'Aceptar',
  };

  private readonly buttonsText = {
    it: { cancel: 'Anulla', accept: 'Accetta' },
    pt: { cancel: 'Cancelar', accept: 'Aceitar' },
    ca: { cancel: 'Cancel·lar', accept: 'Acceptar' },
    en: { cancel: 'Cancel', accept: 'Accept' },
    de: { cancel: 'Abbrechen', accept: 'Akzeptieren' },
    fr: { cancel: 'Annuler', accept: 'Accepter' },
  };

  constructor(
    private customizationService: CustomizationService,
    private customizationStoreService: CustomizationStoreService,
    @Inject(MAT_DIALOG_DATA) public data: { flow: string; lang?: string }
  ) {
    this.customizationStoreService.getFunderConfig().subscribe(
      (config) => {
        if (Object.keys(config).length > 0) {
          this.funderConfig = config;
        }
      },
    );

    this.customizationStoreService.getFunderStyles().subscribe(
      (styles) => {
        if (Object.keys(styles).length > 0) {
          this.funderStyles = styles;
        }
      },
    );

    this.customizationStoreService.getUserID().subscribe(uid => {
      this.customizationService.getCustomizationByFlow(
        uid,
        this.getParsedFlowName(this.data.flow),
        this.customizationStoreService.LANG
      ).then(d => {
        this.flowConfig = d;
        this.setCustomization();
      });
    });
  }

  ngOnInit(): void {
    this.parseButtons(this.resolveLang());
  }

  private resolveLang(): string {
    return normalizeWidgetLang(
      this.data?.lang || this.customizationStoreService.LANG || localStorage.getItem('belender-language')
    );
  }

  private parseButtons(lang: string): void {
    const langKey = normalizeWidgetLang(lang);
    if (this.buttonsText[langKey]) {
      this.texts.accept = this.buttonsText[langKey].accept;
      this.texts.cancel = this.buttonsText[langKey].cancel;
    }
  }

  setCustomization() {
    this.loading = true;

    if (this.flowConfig && this.flowConfig.terms_and_conditions) {
      this.terms_and_conditions = this.flowConfig.terms_and_conditions;
    } else {
      this.terms_and_conditions = `
        <div class="px-10 py-6 rounded-md text-center bg-orange-500/20 text-orange-600">
          <p>No hay términos y condiciones para este flujo </p> 
        </div>`;
    }
    this.loading = false;
  }

  getParsedFlowName(flow) {
    switch(flow) {
      case 'sms':
      case 'Sms':
        return 'SMS';
      case 'clavepin':
      case 'ClavePin':
      case 'CLAVEPIN':
        return 'ClavePin';
      case 'videoid':
        return 'VideoID';
      case 'personal':
      case 'presencial':
          return 'KnownClient';
      case 'client-cert':
          return 'KnownClient';
      default:
        return flow;
    }
  }
}
